import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { REVIEW_STATUS_CODE } from "../constants/AppConstants";
import { ROUTE_PATHS } from "../constants/Router";
import { kIN_1_WEEKS } from "../pages/review/ReviewStatusKeys";
import { dashboardSvg, homeNavSvg, moreSvg, reviewSvg } from "./Assets";
const BottomNav = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();

  const icons = [
    // Define your icon data here
    { icon: <img src={homeNavSvg} alt="home" />, label: "홈", navigateTo: "/" },
    {
      icon: <img src={reviewSvg} alt="review" />,
      label: "리뷰",
      navigateTo: `/review?time=${kIN_1_WEEKS}&search_comment_reg_status_code=`,
    },
    {
      icon: <img src={dashboardSvg} alt="analytics" />,
      label: "분석",
      navigateTo: ROUTE_PATHS.Analytics,
    },
    {
      icon: <img src={moreSvg} alt="more" />,
      label: "전체",
      navigateTo: "/more",
    },
  ];
  const getActive = () => {
    if (location.pathname.includes("/review")) {
      setActiveIndex(1);
    }
    else if (location.pathname.includes(ROUTE_PATHS.Analytics)) {
      setActiveIndex(2);
    }
    else if (location.pathname.includes("/more")) {
      setActiveIndex(3);
    } else {
      setActiveIndex(0);
    }
  };

  useEffect(() => {
    getActive();
  }, [location.pathname]);

  const exludes = [
    "/edit-review",
    "/review-additional-comment",
    "/premium-intro",
  ];
  if (exludes.find((x) => location.pathname.startsWith(x))) {
    return <></>;
  }

  const handleClick = (index) => {
    navigate(icons[index].navigateTo);
    setActiveIndex(index);
  };

  return (
    <div className="bottom-nav-container">
      <ul className="bottom-nav-list">
        {icons.map((item, index) => (
          <li
            key={index}
            className={`bottom-nav-item ${
              activeIndex === index ? "active" : ""
            }`}
            onClick={() => handleClick(index)}
          >
            {item.icon}
            <span
              className={`bottom-nav-label ${
                activeIndex === index ? "" : "hidden"
              }`}
            >
              {item.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BottomNav;
